'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fastdom = require('fastdom');

var _fastdom2 = _interopRequireDefault(_fastdom);

var _Aria2 = require('./Aria');

var _Aria3 = _interopRequireDefault(_Aria2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-underscore-dangle */


/**
 * Manage aria-haspopup elements
 *
 * @param {Object} config - Config options for AriaPopup
 * @param {HTMLElement} config.controller - The controlling element
 * @param {HTMLElement} config.target - The element controlled by `controller`
 * @param {Object} config.attributes - An Object of aria-* attributes to be added to the `target`, where the key completes an 'aria-' attribute name and the value is a valid attribute value.
 *
 * E.g.:
 * const popup = new AriaPopup({
 *   controller: controllingButton,
 *   target: targetElement,
 *   attributes: {
 *     label: 'submenu'
 *     labelledby: 'element-id'
 *     describedby: 'verbose-element-id'
 *   }
 * });
 */
var AriaPopup = function (_Aria) {
  _inherits(AriaPopup, _Aria);

  function AriaPopup(config) {
    _classCallCheck(this, AriaPopup);

    var _this = _possibleConstructorReturn(this, (AriaPopup.__proto__ || Object.getPrototypeOf(AriaPopup)).call(this));

    _this.controller = config.controller;
    _this.target = config.target;
    _this.attributes = config.attributes || {};

    _this.targetElement = _this.target;

    _this.targetAttr = {};
    _this.isExpanded = false;

    // Bind class methods
    _this.setTargetAttributes = _this.setTargetAttributes.bind(_this);
    _this.rovingTabIndex = _this.rovingTabIndex.bind(_this);
    _this.outsideClick = _this.outsideClick.bind(_this);
    _this.keyDownHandler = _this.keyDownHandler.bind(_this);
    _this.keydownTabOut = _this.keydownTabOut.bind(_this);
    _this.keydownEsc = _this.keydownEsc.bind(_this);
    _this.ariaSetup = _this.ariaSetup.bind(_this);
    _this._hide = _this._hide.bind(_this);
    _this._show = _this._show.bind(_this);
    _this._destroy = _this._destroy.bind(_this);
    _this._reset = _this._reset.bind(_this);
    _this.ariaHide = _this.ariaHide.bind(_this);
    _this.ariaShow = _this.ariaShow.bind(_this);
    _this.ariaToggle = _this.ariaToggle.bind(_this);
    _this.ariaDestroy = _this.ariaDestroy.bind(_this);
    _this.ariaReset = _this.ariaReset.bind(_this);

    _this.collectInteractiveChildren();
    _this.setTargetAttributes();
    _Aria3.default.eventPolyfill();
    _this.ariaSetup();
    return _this;
  }

  /**
   * Add initial attributes, establish relationships, and listen for events
   */


  _createClass(AriaPopup, [{
    key: 'ariaSetup',
    value: function ariaSetup() {
      var _this2 = this;

      this.controller.setAttribute('aria-haspopup', 'true');
      this.controller.setAttribute('aria-expanded', 'false');
      this.controller.setAttribute('aria-controls', this.targetId);

      if (this.target !== this.controller.nextElementSibling) {
        this.controller.setAttribute('aria-owns', this.targetId);
      }

      this.target.setAttribute('aria-hidden', 'true');

      Object.keys(this.targetAttr).forEach(function (attr) {
        _this2.target.setAttribute(attr, _this2.targetAttr[attr]);
      });

      this.rovingTabIndex();

      this.controller.addEventListener('click', this.ariaToggle);
      this.target.addEventListener('keydown', this.keyDownHandler);
      document.body.addEventListener('click', this.outsideClick);
    }

    /**
     * Copy attributes over as their full attribute name.
     */

  }, {
    key: 'setTargetAttributes',
    value: function setTargetAttributes() {
      var _this3 = this;

      if ('object' === _typeof(this.attributes)) {
        Object.keys(this.attributes).forEach(function (prop) {
          _this3.targetAttr['aria-' + prop] = _this3.attributes[prop];
        });
      }

      // Configure a target element ID if it doesn't exist.
      if ('' !== this.target.id) {
        this.targetId = this.target.id;
      } else {
        this.targetId = _Aria3.default.generateTargetId(this.target);
        this.target.id = this.targetId;
      }
    }

    /**
     * Close the dialog on outside click.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'outsideClick',
    value: function outsideClick(event) {
      if (this.isExpanded && !this.controller.contains(event.target) && !this.target.contains(event.target)) {
        this.ariaHide();
      }
    }

    /**
     * Handle key presses.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'keyDownHandler',
    value: function keyDownHandler(event) {
      if (this.isExpanded) {
        if (event.keyCode === this.tabKey) {
          this.keydownTabOut(event);
        } else if (event.keyCode === this.escapeKey) {
          event.stopPropagation();
          this.keydownEsc();
        }
      }
    }

    /**
     * Close the dialog on ESC key press.
     */

  }, {
    key: 'keydownEsc',
    value: function keydownEsc() {
      this.ariaHide();
    }

    /**
     * Close submenu on tab-out.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'keydownTabOut',
    value: function keydownTabOut(event) {
      var focusedIndex = Array.prototype.indexOf.call(this.interactiveChildElements, document.activeElement);

      if (event.shiftKey && 0 === focusedIndex) {
        event.preventDefault();
        this.ariaHide();
      } else if (!event.shiftKey && focusedIndex === this.interactiveChildElements.length - 1) {
        this.ariaHide();
      }
    }

    /**
     * Prevent hidden menu items from having focus.
     */

  }, {
    key: 'rovingTabIndex',
    value: function rovingTabIndex() {
      var _this4 = this;

      this.collectInteractiveChildren();

      Array.prototype.forEach.call(this.interactiveChildElements, function (child) {
        if (_this4.isExpanded) {
          child.removeAttribute('tabindex');
        } else {
          child.setAttribute('tabindex', '-1');
        }
      });
    }

    /**
     * Externally-exposed hide method
     */

  }, {
    key: 'ariaHide',
    value: function ariaHide() {
      _fastdom2.default.mutate(this._hide);
    }

    /**
     * ARIA-hide the target element.
     *
     * @private
     */

  }, {
    key: '_hide',
    value: function _hide() {
      if (this.target.contains(document.activeElement)) {
        this.controller.focus();
      }

      this.controller.setAttribute('aria-expanded', 'false');
      this.target.setAttribute('aria-hidden', 'true');

      this.isExpanded = false;

      var hide = null;
      var detail = { expanded: this.isExpanded };
      hide = _Aria3.default.createAriaEvent('popuphide', detail);
      this.controller.dispatchEvent(hide);

      this.rovingTabIndex();
    }

    /**
     * Externally-exposed show method
     */

  }, {
    key: 'ariaShow',
    value: function ariaShow() {
      _fastdom2.default.mutate(this._show);
    }

    /**
     * ARIA-show the target element.
     *
     * @private
     */

  }, {
    key: '_show',
    value: function _show() {
      this.controller.setAttribute('aria-expanded', 'true');
      this.target.setAttribute('aria-hidden', 'false');

      this.isExpanded = true;

      var show = null;
      var detail = { expanded: this.isExpanded };
      show = _Aria3.default.createAriaEvent('popupshow', detail);
      this.controller.dispatchEvent(show);

      this.collectInteractiveChildren();
      this.rovingTabIndex();
      this.setFocusToFirstItem();
    }

    /**
     * Toggle ARIA attributes.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'ariaToggle',
    value: function ariaToggle(event) {
      event.preventDefault();
      if (this.isExpanded) {
        this.ariaHide();
      } else {
        this.ariaShow();
      }
    }

    /**
     * Externally-exposed destroy method
     */

  }, {
    key: 'ariaDestroy',
    value: function ariaDestroy() {
      _fastdom2.default.mutate(this._destroy);
    }

    /**
     * Remove all ARIA attributes added by this class.
     *
     * @private
     */

  }, {
    key: '_destroy',
    value: function _destroy() {
      var _this5 = this;

      if (this.target.contains(document.activeElement)) {
        this.controller.focus();
      }

      this.controller.removeAttribute('aria-haspopup');
      this.controller.removeAttribute('aria-expanded');
      this.controller.removeAttribute('aria-controls');
      this.controller.removeAttribute('aria-owns');

      this.target.removeAttribute('aria-hidden');

      Object.keys(this.targetAttr).forEach(function (attr) {
        _this5.target.removeAttribute(attr, _this5.targetAttr[attr]);
      });

      this.isExpanded = false;

      this.collectInteractiveChildren();

      Array.prototype.forEach.call(this.interactiveChildElements, function (child) {
        child.removeAttribute('tabindex');
      });

      var destroy = null;
      var detail = { expanded: this.isExpanded };
      destroy = _Aria3.default.createAriaEvent('popupdestroy', detail);
      this.controller.dispatchEvent(destroy);
    }

    /**
     * Externally-exposed reset method
     */

  }, {
    key: 'ariaReset',
    value: function ariaReset() {
      _fastdom2.default.mutate(this._reset);
    }

    /**
     * Reset ARIA attributes.
     *
     * @private
     */

  }, {
    key: '_reset',
    value: function _reset() {
      this.ariaSetup();

      if (this.target.contains(document.activeElement)) {
        this.controller.focus();
      }

      var reset = null;
      var detail = { expanded: false };
      reset = _Aria3.default.createAriaEvent('popupreset', detail);
      this.controller.dispatchEvent(reset);
    }
  }]);

  return AriaPopup;
}(_Aria3.default);

exports.default = AriaPopup;


//////////////////
// WEBPACK FOOTER
// ./~/js-component-framework/lib/plugins/AriaPopup.js
// module id = ./node_modules/js-component-framework/lib/plugins/AriaPopup.js
// module chunks = 7